import React, { useEffect, useState } from "react";
import "./Style.css";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Comingsoon from "../../ComingSoon/ComingSoon";
import callImg from "../../../Assets/call.svg";
import LoctionImg from "../../../Assets/loction.svg";
import userprofile from "../../../Assets/user.svg";
import GrowIcons from "../../../Assets/grow.svg";
import Companyimg from "../../../Assets/company.svg";
import GlobalImg from "../../../Assets/Globe.svg";
import linkedin from "../../../Assets/linkedin.svg";
import visitLinkImage from "../../../Assets/visit-link.svg";
import IndustryImage from "../../../Assets/office-building.png";
import { Link } from "react-router-dom/dist";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import SpeedIcon from "@mui/icons-material/Speed";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  APIDataUrl,
  APITokenUrl,
  getConfidenceScore,
} from "../../../Utils/Utils";
import { Tooltip } from "@mui/material";
import moment from "moment";
import greentrendindicator from "../../../Assets/greentrendindicator.svg";
import redtrendindicator from "../../../Assets/redtrendindicator.svg";
import EmployeesTablePdf from "../../../Pages/AiLeads/CompanyProfileScreen/EmployeesTable/EmployeesTablePdf";
import CriePdf from "./Crie/CriePdf";
import axios from "axios";
import CustomNewsSearchDetails from "./CostomNewsSearchDetails/CostomNewsSearchDetails";
import PdfCustomNewsSearch from "./CostomNewsSearchDetails/PdfCustomNewsSearch";

const OrganizationDetailsPagePdf = ({
  dataForInformation,
  value,
  setValue,
  informationData,
  handleTrackingdata,
  rowData,
  setDisableRequestUpdate,
  requestUpdateRecord,
  setRequestUpdateRecord,
  setIsSalesForceTrigger,
  isSalesForceTrigger,
  setShowSalesForce,
  industryLogo,
  setIndustryLogo,
}) => {
  const isBranchLocationsDisabled = true;
  const [showIndicator, setShowIndicator] = useState(false);
  const [favoritesLeads, setFavoritesLeads] = React.useState([]);
  const [favoritesList, setFavoritesList] = React.useState([]);
  const [crieNavigate, setCrieNavigate] = useState();

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const getIndustryLogo = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_company_logo_url?org_id=${dataForInformation?.org_id}`,
    };
    axios(option)
      .then((response) => {
        setIndustryLogo(response?.data?.data?.company_logo_url);
      })
      .catch(() => {});
  };
  useEffect(() => {
    if (dataForInformation?.org_id) {
      getIndustryLogo();
    }
  }, [dataForInformation?.org_id]);
  return (
    <div>
      {/* Data Sync Section  */}
      <div className="data-sync-c-rate-org">
        <div className="datasync-line-c-score">
          <span className="datasync-line">Data Sync: </span>{" "}
          <span className="datasync-line-data">
            {dataForInformation?.updated_at
              ? moment(dataForInformation.updated_at).format("MM.DD.YY")
              : "No update information available"}
          </span>{" "}
        </div>
        <div className="datasync-line-c-score">
          <Tooltip
            title={
              "This score reflects a combination of record completeness, freshness, and data source reliability."
            }
          >
            <span>
              <span className="datasync-line">Data Confidence Score:</span>
              <span className="datasync-line-data">
                {dataForInformation?.confidence_score
                  ? getConfidenceScore(dataForInformation?.confidence_score)
                  : "No update information available"}
              </span>
            </span>
          </Tooltip>
        </div>
      </div>

      {/* Organization Detais Page  */}
      <Box className="company-profile-main-tabs-data" sx={{ width: "100%" }}>
        {/* for pdf  */}

        <>
          <div
            style={{
              paddingTop: "30px",
              backgroundColor: "F5F6FA",
              pageBreakInside: "avoid",
            }}
          >
            <div className="cp_inner_container_leads">
              <section className="">
                <div className=" CompanyProfile-outter-container">
                  <div className="CompanyProfile-flex-container">
                    <div className="CompanyProfile-flex-outter-container">
                      <div className="CompanyProfile-img">
                        <img
                          src={industryLogo}
                          style={{ width: "100%", height: "100%" }}
                          onError={(e) => (e.target.src = IndustryImage)}
                        />
                      </div>
                      <div>
                        <h3 className="Netflix-heading">
                          {dataForInformation?.name
                            ? dataForInformation?.name
                            : "-"}
                        </h3>
                        <div className="CompanyProfile-content">
                          <img
                            className="CompanyProfile-icons"
                            src={GlobalImg}
                            alt=""
                          />
                          {dataForInformation?.website_url ? (
                            <Link
                              to={dataForInformation?.website_url}
                              target="_blank"
                              className="clickable-link-for-website"
                            >
                              <p>
                                {dataForInformation?.website_url?.split(
                                  "www.",
                                )?.[1]
                                  ? dataForInformation?.website_url?.split(
                                      "www.",
                                    )?.[1]
                                  : dataForInformation?.website_url?.split(
                                        "http://",
                                      )?.[1]
                                    ? dataForInformation?.website_url?.split(
                                        "http://",
                                      )?.[1]
                                    : dataForInformation?.website_url?.split(
                                          "https://",
                                        )?.[1]
                                      ? dataForInformation?.website_url?.split(
                                          "https://",
                                        )?.[1]
                                      : dataForInformation?.website_url}
                              </p>
                            </Link>
                          ) : (
                            <p>Not Available</p>
                          )}
                        </div>
                        <div className="CompanyProfile-content">
                          <img
                            className="CompanyProfile-icons"
                            src={callImg}
                            alt=""
                          />
                          <p>
                            {dataForInformation?.phone_number
                              ? dataForInformation?.phone_number
                              : "Not Available"}
                          </p>
                        </div>
                        <div className="company-profile-mention-main">
                          <div className="company-profile-mention-b1">
                            <img
                              src={linkedin}
                              alt=""
                              style={{ width: "17px", height: "17px" }}
                            />
                            {dataForInformation?.linkedin
                              ? dataForInformation.linkedin.split(".com/")?.[1]
                              : "-"}
                          </div>
                          <div>
                            <a
                              href={dataForInformation?.linkedin}
                              target="_blank"
                            >
                              <img
                                src={visitLinkImage}
                                alt=""
                                style={{ width: "17px", height: "15px" }}
                              />
                            </a>
                          </div>
                        </div>
                        <div className="CompanyProfile-content">
                          <img
                            className="CompanyProfile-icons"
                            src={LoctionImg}
                            alt=""
                          />
                          <p>{`${
                            dataForInformation?.street
                              ? dataForInformation?.street + `,`
                              : dataForInformation?.street === null
                                ? ""
                                : dataForInformation?.street
                          } ${
                            dataForInformation?.location_identifiers
                              ? dataForInformation?.location_identifiers + `,`
                              : dataForInformation?.location_identifiers ===
                                  null
                                ? ""
                                : dataForInformation?.location_identifiers
                          } ${
                            dataForInformation?.postalcode
                              ? dataForInformation?.postalcode + `,`
                              : dataForInformation?.postalcode === null
                                ? ""
                                : dataForInformation?.postalcode
                          } ${
                            dataForInformation?.country
                              ? dataForInformation?.country
                              : dataForInformation?.country === null
                                ? ""
                                : dataForInformation?.country
                          }`}</p>
                        </div>
                      </div>
                    </div>

                    <div className="CompanyProfile-cont-rightside">
                      <div className="CompanyProfile-content">
                        <SpeedIcon className="CompanyProfile-icons ai-score-icon" />
                        <p>
                          Orbit Score -
                          {dataForInformation?.ai_score !== null &&
                          dataForInformation?.ai_score !== undefined
                            ? dataForInformation?.ai_score
                            : "NA"}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={userprofile}
                          alt=""
                        />
                        <p>
                          Employees-
                          {dataForInformation?.num_employees
                            ? dataForInformation?.num_employees
                            : "Not Available"}
                          {showIndicator && (
                            <img
                              style={{
                                paddingLeft: "10px",
                                width: "18px",
                                height: "13px",
                              }}
                              src={
                                dataForInformation?.num_employees_movement >
                                dataForInformation?.num_employees
                                  ? greentrendindicator
                                  : redtrendindicator
                              }
                              alt="Trend Indicator"
                            />
                          )}{" "}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={GrowIcons}
                          alt=""
                        />
                        <p>
                          Annual revenue -
                          {dataForInformation?.revenue_range
                            ? dataForInformation?.revenue_range
                            : "Not Available"}
                          {showIndicator && (
                            <img
                              style={{
                                paddingLeft: "10px",
                                width: "18px",
                                height: "13px",
                              }}
                              src={
                                dataForInformation?.revenue_range_movement >
                                dataForInformation?.revenue_range
                                  ? greentrendindicator
                                  : redtrendindicator
                              }
                              alt="Revenue Trend Indicator"
                            />
                          )}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={Companyimg}
                          alt=""
                        />
                        <p className="industry-mentions">
                          Industry/ Sector -{" "}
                          {dataForInformation?.categories
                            ?.split(/(?<=,)|\s+/) // Split by spaces while keeping commas intact
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase(),
                            )
                            .join(" ")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="CompanyProfile-infomation-main">
                    <div>
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          expandIcon={<KeyboardArrowDownIcon />}
                          aria-controls="panel2-content"
                          id="panel2-header"
                        >
                          <Typography className="company_bio_trio">
                            Organization Bio
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography className="CompanyProfile-infomation">
                            <p className="industry-mentions">
                              {dataForInformation?.description
                                ? dataForInformation.description.replace(
                                    /(^|\.\s+)([a-z])/g,
                                    (match) => match.toUpperCase(),
                                  )
                                : "Not Available"}
                            </p>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          {/* Crie Section Starts  */}
          <div style={{ pageBreakInside: "avoid", breakBefore: "page" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs className="Companydata" aria-label="basic tabs example">
                <Tab label="Company and Relationship Intelligence Explorer (CRIE)" />
              </Tabs>
            </Box>
            <CustomTabPanel
              disabled={isBranchLocationsDisabled}
              className="company_tabs_data_cont"
            >
              <CriePdf
                dataForInformation={dataForInformation}
                crieNavigate={crieNavigate}
                setCrieNavigate={setCrieNavigate}
              />
            </CustomTabPanel>
            <p>
              Disclaimer : You can always update your selections to view more
              results on your download.
            </p>
          </div>
          <div style={{ pageBreakInside: "avoid", breakBefore: "page" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs className="Companydata" aria-label="basic tabs example">
                <Tab label="News/Events" />
              </Tabs>
            </Box>
            <CustomTabPanel
              disabled={isBranchLocationsDisabled}
              className="company_tabs_data_cont"
            >
              <Comingsoon
                dataForInformation={dataForInformation}
                generatePdf={true}
              />
            </CustomTabPanel>
          </div>
          <div style={{ pageBreakInside: "avoid", breakBefore: "page" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs className="Companydata" aria-label="basic tabs example">
                <Tab label="Custom News Search" />
              </Tabs>
            </Box>
            <CustomTabPanel
              disabled={isBranchLocationsDisabled}
              className="company_tabs_data_cont"
            >
              <PdfCustomNewsSearch dataForInformation={dataForInformation} />
            </CustomTabPanel>
          </div>
          <div style={{ pageBreakInside: "avoid", breakBefore: "page" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs className="Companydata" aria-label="basic tabs example">
                <Tab label="Employees " />
              </Tabs>
            </Box>
            <CustomTabPanel className="company_tabs_data_cont">
              <EmployeesTablePdf
                informationData={informationData}
                favoritesLeads={favoritesLeads}
                setFavoritesLeads={setFavoritesLeads}
                favoritesList={favoritesList}
                handleTrackingdata={handleTrackingdata}
                setValue={setValue}
                dataForInformation={dataForInformation}
                rowData={rowData}
                setDisableRequestUpdate={setDisableRequestUpdate}
                requestUpdateRecord={requestUpdateRecord}
                setRequestUpdateRecord={setRequestUpdateRecord}
                setIsSalesForceTrigger={setIsSalesForceTrigger}
                isSalesForceTrigger={isSalesForceTrigger}
                setShowSalesForce={setShowSalesForce}
                setCrieNavigate={setCrieNavigate}
              />
            </CustomTabPanel>
            <p>
              Disclaimer : You can always update your selections to view more
              results on your download.
            </p>
          </div>
        </>
      </Box>
    </div>
  );
};

export default OrganizationDetailsPagePdf;
